import {createAction} from '@reduxjs/toolkit';

import {showLeftDrawer} from './ui.js';

import {DRAWERS, TOURS} from '@app/constants';

export const setTour = createAction('SET_TOUR');
export const runTour = createAction('RUN_TOUR');

export const startTour = tour => dispatch => {
  if (!tour || tour === TOURS.MAIN) {
    dispatch(showLeftDrawer(''));
  } else {
    dispatch(showLeftDrawer(DRAWERS.COLLECTIONS));
  }
  setTimeout(() => {
    dispatch(setTour(tour));
  }, 200);
};

export const endTour = createAction('END_TOUR');

export const setTourIndex = createAction('SET_TOUR_INDEX');
